export const LoadGoogleMaps = () => {
  return new Promise((resolve, reject) => {
    // If already loaded, just resolve
if (typeof window !== "undefined" && (window as any).google && (window as any).google.maps) {
      resolve((window as any).google);
      return;
    }

    // If script already exists but not yet loaded, wait for it
    const existingScript = document.getElementById("google-maps-script");
    if (existingScript) {
      existingScript.addEventListener("load", () => resolve((window as any).google));
      existingScript.addEventListener("error", reject);
      return;
    }

    // Otherwise, create new script
    const script = document.createElement("script");
    script.id = "google-maps-script";
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_MAP_KEY}&libraries=places,geometry`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve((window as any).google);
    script.onerror = (err) => reject(err);

    document.body.appendChild(script);
  });
};
